module.exports = __webpack_public_path__ + "media/images/freelance_ic-e431315473c03e3dbca07a9b3719618e.svg";